import React from "react";
import { motion } from "framer-motion";

const SocialProof = ({ codingPageUrl, invitePageUrl }) => {
  return (
    <section id="social" className="py-20 bg-indigo-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-3xl md:text-4xl font-extrabold text-indigo-900">
          See Us in Action
        </motion.h2>
        <p className="text-gray-600 mt-2">Real learners. Real progress.</p>

        <div className="mt-10 grid md:grid-cols-3 gap-6">
          <div className="rounded-2xl overflow-hidden border bg-white">
            <video className="w-full aspect-video"  autoPlay muted loop playsInline poster="/intro-poster.jpg">
              <source src="/Dosh.mp4" type="video/mp4" />
            </video>
            <div className="p-4">
              <h3 className="font-semibold text-indigo-900">Dosh Learning Hub</h3>
              <p className="text-sm text-gray-600">Updates, wins, and class highlights. Coding in progress.</p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border bg-white">
            <div className="aspect-video">
               <video className="w-full aspect-video"  autoPlay muted loop playsInline poster="/intro-poster.jpg">
              <source src="/invites.mp4" type="video/mp4" />
            </video>
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-indigo-900">Teemah Smart Invite</h3>
              <p className="text-sm text-gray-600">Smart electronic invitations with RSVP tracking.</p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden border bg-white">
            <video className="w-full aspect-video"  autoPlay muted loop playsInline poster="/intro-poster.jpg">
              <source src="/forex.mp4" type="video/mp4" />
            </video>
            <div className="p-4">
              <h3 className="font-semibold text-indigo-900">Forex Trading</h3>
              <p className="text-sm text-gray-600">Learn how to analyze candlesticks and maximize your trading profits.</p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
